'use client'

import { useFormatPrice } from '@/lib/timed-ui/use-format-price'

interface BookingSummaryProps {
  totalPrice: number
  ticketCount: number
}

const BookingSummary = ({ totalPrice, ticketCount }: BookingSummaryProps) => {
  const formatPrice = useFormatPrice()
  if (ticketCount <= 0) {
    return (
      <div className="pt-5 border-t border-surface-border">
        <div className="text-sm text-text-tertiary text-center">
          Select tickets to see your total
        </div>
      </div>
    )
  }

  return (
    <div className="pt-5 border-t border-surface-border">
      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <div className="text-sm text-text-secondary">
            {ticketCount} {ticketCount === 1 ? 'ticket' : 'tickets'}
          </div>
          <div className="text-sm font-medium text-text-primary">
            {formatPrice(totalPrice)}
          </div>
        </div>
        <div className="flex items-center justify-between pt-1.5 border-t border-surface-border/50">
          <div className="text-sm font-semibold text-text-primary">
            Total
          </div>
          <div className="text-xl font-heading font-bold text-text-primary">
            {formatPrice(totalPrice)}
          </div>
        </div>
      </div>
      <p className="text-xs text-text-tertiary text-right mt-1">
        All prices include applicable fees
      </p>
    </div>
  )
}

export default BookingSummary
